import * as React from 'react'

export interface IBlockTransitionContext {
  addChild?: () => any
  removeChild?: () => any
}

export const BlockTransitionContext = React.createContext<IBlockTransitionContext>({
})
